/* Robevia 2026-10-31: shared cart helpers for the rv-* sections (quick add + product page). */
(function () {
  if (window.RV) return;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  async function refreshCart(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    try {
      var res = await fetch(root() + '?sections=cart-drawer-section', { credentials: 'same-origin' });
      var data = await res.json();
      var html = data['cart-drawer-section'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-drawer__inner');
        var current = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (fresh && current) current.replaceWith(fresh);
      }
    } catch (e) {}
    try {
      if (count === null) {
        var r = await fetch(root() + 'cart.js', { credentials: 'same-origin' });
        count = (await r.json()).item_count;
      }
      var icon = document.querySelector('cart-icon');
      if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count);
    } catch (e) {}
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  async function add(variantId, quantity) {
    var res = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    });
    var body = await res.json();
    if (!res.ok) throw new Error(body.description || body.message || 'Could not add to bag');
    var cart = null;
    try {
      cart = await (await fetch(root() + 'cart.js', { credentials: 'same-origin' })).json();
    } catch (e) {}
    var opened = await refreshCart(cart);
    if (!opened) window.location.href = root() + 'cart';
    return cart;
  }

  function businessDays(n) {
    var d = new Date();
    var k = 0;
    while (k < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) k++;
    }
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /* Quick add on product cards */
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-rv-quick]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      await add(btn.getAttribute('data-rv-quick'), 1);
      btn.textContent = '✓';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; btn.removeAttribute('aria-busy'); }, 1600);
    } catch (err) {
      btn.textContent = label;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      alert(err.message);
    }
  });

  window.RV = { add: add, refreshCart: refreshCart, businessDays: businessDays };
})();
